import type { ReservationSlotTemplateRepository } from '../../application/reservationSlots/ports/ReservationSlotTemplateRepository';
import type { ReservationSlotSettingsRepository } from '../../application/reservationSlots/ports/ReservationSlotSettingsRepository';
import type { ReservationSlotRepository } from '../../application/reservationSlots/ports/ReservationSlotRepository';

// 実API実装
import { reservationSlotTemplateRepository as templateRepositoryImpl } from './ReservationSlotTemplateRepositoryImpl';
import { reservationSlotSettingsRepository as settingsRepositoryImpl } from './ReservationSlotSettingsRepositoryImpl';
import { reservationSlotRepository as slotRepositoryImpl } from './ReservationSlotRepositoryImpl';

// モック実装
import { reservationSlotTemplateRepositoryMock } from './mock/ReservationSlotTemplateRepositoryMock';
import { reservationSlotSettingsRepositoryMock } from './mock/ReservationSlotSettingsRepositoryMock';
import { reservationSlotRepositoryMock } from './mock/ReservationSlotRepositoryMock';

/**
 * モック/実API切替フラグ
 *
 * @description
 * true: メモリ内モックを使用（バックエンド未実装時）
 * false: 実APIを使用（バックエンド完成後）
 *
 * バックエンドの解放枠APIが実装できたら、このフラグを false にするだけで
 * 全タブが一括で実API参照に切り替わる。
 * 環境変数 REACT_APP_USE_RESERVATION_SLOT_MOCK で上書きも可能。
 */
const envFlag = process.env.REACT_APP_USE_RESERVATION_SLOT_MOCK;
const USE_MOCK = envFlag !== undefined ? envFlag === 'true' : true;

export const reservationSlotTemplateRepository: ReservationSlotTemplateRepository = USE_MOCK
  ? reservationSlotTemplateRepositoryMock
  : templateRepositoryImpl;

export const reservationSlotSettingsRepository: ReservationSlotSettingsRepository = USE_MOCK
  ? reservationSlotSettingsRepositoryMock
  : settingsRepositoryImpl;

export const reservationSlotRepository: ReservationSlotRepository = USE_MOCK
  ? reservationSlotRepositoryMock
  : slotRepositoryImpl;
